import { useState, useEffect } from "react";
import BarGraph from "../UI/BarGraph";
import { arrayToCsv } from "../../util/arrayToCsv";
import { requestAdminAPI } from "../../api/posh-api";
import Heading from "../UI/Heading";
import LoaderGraph from "../UI/LoaderGraph";
import { TbFileTypeCsv } from "react-icons/tb";

const categories = [
  "booking",
  "subscription",
  "deposit",
  "damage",
  "insurance",
  "tolls",
  "ticket",
  "miles",
  "violation",
  "charging",
  "other",
];

export default function RevenueGraph() {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [type, setType] = useState("");
  const [data, setData] = useState([]);
  const [show, setShow] = useState(true);
  const [loading, setLoading] = useState(true);

  // ============================================= FETCH REVENUE FOR VEHICLES
  const fetchRevenueHandler = async () => {
    try {
      setLoading(true);
      const data = await requestAdminAPI("fetch-revenue", {
        year: selectedYear,
        type: type,
      });
      setData(data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // =================== DOWNLOAD CSV ===================
  const downloadCSV = () => {
    arrayToCsv(data, `${selectedYear}-revenue.csv`);
  };


  useEffect(() => {
    fetchRevenueHandler();
  }, [selectedYear, type]);

  return (
    <div>
      <Heading
        title="Revenue Graph"
        isBackArrow={false}
        onClick={() => setShow(!show)}
      >
        <select
          className="text-sm bg-transparent border-b rounded-none cursor-pointer input"
          defaultValue={type}
          onChange={(e) => setType(e.target.value)}
        >
          <option value="">All</option>
          {categories.map((category) => (
            <option key={category} value={category}>
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </option>
          ))}
        </select>
        <select
          className="text-sm bg-transparent border-b rounded-none cursor-pointer input"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          {Array.from(
            { length: new Date().getFullYear() - 2022 + 1 },
            (_, i) => {
              return (
                <option key={i} value={2022 + i}>
                  {2022 + i}
                </option>
              );
            }
          )}
        </select>
        <TbFileTypeCsv onClick={downloadCSV} className="self-end text-2xl icon" />
      </Heading>
      {loading ? (
        <LoaderGraph />
      ) : (
        show && <BarGraph data={data} secondary="delinquent" />
      )}
    </div>
  );
}
